import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConsultaBarcodeMultiploService } from 'src/app/services/consulta-barcode-multiplo/consulta-barcode-multiplo.service';

// export interface DialogData {
//   barcodeFinal: string;
// }



@Component({
  selector: 'app-modal-area-transferencia',
  templateUrl: './modal-area-transferencia.component.html',
  styleUrls: ['./modal-area-transferencia.component.scss']
})
export class ModalAreaTransferenciaComponent implements OnInit {
  isLoading: boolean = false;
  barCodeFinal: string;

  formBarcodes = new FormGroup({
    codigoBarras: new FormControl('', Validators.required)
  });
  get codigoBarras() { return this.formBarcodes.get('codigoBarras').value; }

  constructor(
    public barcodeMultiplosService: ConsultaBarcodeMultiploService,
    public dialogRef: MatDialogRef<ModalAreaTransferenciaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    data ? this.barCodeFinal = data : this.barCodeFinal = null;
  }

  ngOnInit() {
    this.isLoading = false;
  }

  barCodesConverter() {
    this.barCodeFinal = this.codigoBarras.replace(/\n/g, "&Barcode=");
    this.dialogRef.close(this.barCodeFinal);
  }

}
